var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#6366f1",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.00282,0) scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.646,4.745c-0.208,0 -0.377,0.077 -0.465,0.22c-0.091,0.148 -0.097,0.321 0,0.514l2.348,4.06c0.004,0.008 0.004,0.017 0,0.024l-3.668,6.481c-0.096,0.191 -0.091,0.39 0,0.538c0.088,0.142 0.232,0.245 0.44,0.245h3.473c0.518,0 0.752,-0.365 0.929,-0.685c0,0 3.602,-6.356 3.742,-6.603c-0.014,-0.024 -2.373,-4.159 -2.373,-4.159c-0.172,-0.306 -0.447,-0.635 -0.978,-0.635z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.186,0c-0.517,0 -0.741,0.326 -0.927,0.659c0,0 -7.457,13.224 -7.702,13.658c0.012,0.024 4.918,9.023 4.918,9.023c0.172,0.308 0.437,0.66 0.967,0.66h3.458c0.208,0 0.371,-0.079 0.459,-0.221c0.092,-0.148 0.09,-0.343 -0.007,-0.535l-4.88,-8.915c-0.004,-0.007 -0.004,-0.016 0,-0.023l7.664,-13.551c0.096,-0.191 0.098,-0.386 0.007,-0.534c-0.088,-0.142 -0.252,-0.221 -0.46,-0.221h-3.497z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17ab5b1dd77bb2165d46159deb0c5a31.svg";
export { ForwardRef as ReactComponent };